import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const isFirstLevel = pathSegments.length === 1;

  if (isHome) return null;

  return (
    <div className="header">
      <div
        className="home-button clickable"
        onClick={() => navigate('/')}
        style={{ height: '80%', width: 'auto', aspectRatio: '1/1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <img src="/assets/higher-ed/main.png" alt="Home" style={{ width: '100%' }} />
      </div>
      <div
        className={`back-button${isFirstLevel ? ' disabled' : ' clickable'}`}
        onClick={isFirstLevel ? undefined : () => navigate(-1)}
        style={{ height: '80%', width: 'auto', aspectRatio: '1/1', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: isFirstLevel ? 0.4 : 1, pointerEvents: isFirstLevel ? 'none' : 'auto' }}
      >
        <img src="/assets/higher-ed/back.png" alt="Back" style={{ width: '100%' }} />
      </div>
    </div>
  );
}

export default Header;
